/**
 * The model named in the Draft Payroll page title. Mirrors the two tiles on
 * the Reports page that lead here, so the title matches what was clicked.
 *
 * NX-5228: the RCT page on an Irish tenant still read "Draft Payroll (CIS)" —
 * the Reports tile had already been renamed to RCT, the page title had not.
 */
export const draftPayrollModelLabel = ({
  isCisReportPage,
  isBureau,
  isIreland,
}: {
  isCisReportPage: boolean;
  isBureau: boolean;
  isIreland: boolean;
}): string => {
  if (isCisReportPage) return isIreland ? 'RCT' : 'CIS';
  if (isBureau) return isIreland ? 'PAYE/RCT' : 'PAYE';
  return 'PAYE/Umbrella';
};
